// eslint-disable-next-line @trello/export-matches-filename
import { Noun, Verb, trackUe } from '@trello/analytics';
import {
  Analytics,
  ActionType,
  ActionSubjectType,
  ActionSubjectIdType,
  SourceType,
} from '@trello/atlassian-analytics';

interface EmailHygieneAnalyticsParams {
  verb: Verb;
  noun: Noun;
  method: string;
  context?: object;
  actionSubject: ActionSubjectType;
  action: ActionType;
  actionSubjectId: ActionSubjectIdType;
  source: SourceType;
}

export const track = ({
  verb,
  noun,
  method,
  context,
  actionSubject,
  actionSubjectId,
  action,
  source,
}: EmailHygieneAnalyticsParams) => {
  //Send Snowplow Analytics
  trackUe({
    category: Noun.EMAIL_HYGIENE,
    verb: verb,
    directObj: noun,
    method: method,
    context: JSON.stringify(context),
  });

  //Send Atlassian Analytics
  Analytics.sendUIEvent({
    action,
    actionSubject,
    actionSubjectId,
    source,
    attributes: context,
  });
};
